import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserJoinRequest } from "src/app/domain/models/UserJoinRequest";

@Injectable({providedIn: 'root'})
export abstract class UserJoinRequestGateway {
  abstract create(userJoinRequest: UserJoinRequest): Observable<UserJoinRequest>
  abstract getById(id: string): Observable<UserJoinRequest>
}
